import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router'
import PropTypes from 'prop-types'

// Actions
import {
  trackHomeDigestView,
  trackVideoMailerView,
} from '../../../../actions/trackingSource'
import { setActiveTab } from '../../../../actions/navigation'
import { closeLoansNow } from '../../../../actions/homeowner'

// Selectors
import { selectHomeId } from '../../../../store/selectors/home'
import { selectCustomerLegacyRef } from '../../../../store/selectors/customerProfile'
import { selectHomeDigestLoading } from '../../../../store/selectors/display'
import { hasCustomerToken } from '../../../../auth'

// Components
import Dashboard from '../../../../Components/homeowners/Dashboard'
import Intro from '../../../../Components/homeowners/Intro'
import TextUpdatesCallout from '../../../../Components/shared/TextUpdatesCallout'
import OpeningVideo from '../../../../Components/shared/OpeningVideo'
import AppLayout from '../../../../App/Layout/AppLayout'
import { AgentNavigation } from '../../../../App/AgentNavigation'
import { SkipNavContent } from '@homebot/shared-ui-swashbuckle'

// Hooks
import { useOpeningVideo } from '../../../../hooks/useOpeningVideo'

// Utils
import { TAB_NAMES } from '../../../../mappings/navigation'
import { ROUTE_KEY_HOME } from '../../../../constants/routes'
import Footer from '../../../../Components/shared/Footer'

const propTypes = {
  errorModal: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.func,
    PropTypes.node,
    PropTypes.bool,
  ]),
  notFound: PropTypes.bool,
  match: PropTypes.shape({
    path: PropTypes.string,
    url: PropTypes.string,
    isExact: PropTypes.bool,
    params: PropTypes.object,
  }),
}

const HomeownerDigest = ({ errorModal, notFound, match }) => {
  const {
    displayWelcomeVideo,
    displayEmailVideo,
    videoType: videoSource,
    videoId,
    audience: audienceType,
  } = useOpeningVideo()
  const dispatch = useDispatch()
  const [tracked, setTracked] = useState([])
  const homeId = useSelector(selectHomeId)
  const agentId = useSelector(selectCustomerLegacyRef)
  const loading = useSelector(selectHomeDigestLoading)
  const displayOpeningVideo = displayEmailVideo || displayWelcomeVideo
  const shouldTrack = agentId && homeId && !loading && !tracked.includes(homeId)
  const showLoading = !errorModal && loading
  const shouldTrackVideoView = displayEmailVideo && shouldTrack

  if (shouldTrackVideoView) {
    const eventProperties = {
      audienceType,
      videoId,
      videoSource,
    }
    dispatch(trackVideoMailerView(eventProperties))
  }

  useEffect(() => {
    dispatch(setActiveTab(TAB_NAMES.HOMES))

    if (shouldTrack) {
      dispatch(trackHomeDigestView())
      setTracked([...tracked, homeId])
    }
  }, [homeId, shouldTrack, dispatch, tracked])

  useEffect(() => {
    dispatch(closeLoansNow())
  }, [dispatch])

  return (
    <>
      <AppLayout
        enableAgentDropdown
        error={errorModal}
        loading={showLoading}
        match={match}
      >
        {!errorModal && (
          <>
            <SkipNavContent />
            {hasCustomerToken() && (
              <AgentNavigation routeKey={ROUTE_KEY_HOME} />
            )}
            {displayOpeningVideo && <OpeningVideo />}
            <Intro />
            <Dashboard subdue={!match.isExact} />
            <Footer reportType='home' />
            <TextUpdatesCallout />
          </>
        )}
      </AppLayout>
      {notFound && <Redirect to='/not-found' />}
    </>
  )
}

HomeownerDigest.propTypes = propTypes

export default HomeownerDigest
